<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bkBwp1/tc-custom/9780830871209.jpg?1696025011357" alt="This image is the cover for the book Seasoned Speech"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Seasoned Speech
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>The Christian faith depends to a great degree on persuasion.</strong> In one of his letters to early Christians, the apostle Paul wrote, "Let your speech always be gracious, seasoned with salt, so that you may know how you ought to answer everyone" (Col. 4:6). Yet rhetoric—the art of persuasion—has been largely ignored by most Christians. In this book, James Beitler seeks to renew interest in and hunger for an effective Christian rhetoric by closely considering the work of five beloved Christian communicators: C. S. Lewis, Dorothy L. Sayers, Dietrich Bonhoeffer, Desmond Tutu, and Marilynne Robinson. Moreover, he situates these reflections within the Christian liturgical seasons for the essential truths they convey. These writers collectively demonstrate that being a master of rhetoric is not antithetical to authentic Christian witness. Indeed, being a faithful disciple of Christ means practicing a rhetoric that beneficially and persuasively imparts the surprising truth of the gospel. It means having seasoned speech.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James E. Beitler III
      </h2>
      
      <p class="authorDescription body article"><p>James E. Beitler III (PhD, University of Michigan) is associate professor of English at Wheaton College, where he is the director of First-Year Writing and also coordinates the Writing Fellows Program. He is the author of <em>Remaking Transitional Justice in the United States: The Rhetorical Authorization of the Greensboro Truth and Reconciliation Commission.</em> </p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?398525e7